"use client";

import React from "react";
import { MapPin, Mail, Phone, Monitor, Calendar, Building, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const contactDetails = [{
  icon: MapPin,
  label: "Indirizzo",
  value: "Via Lorenzo Ghiberti 21, 35134 Padova"
}, {
  icon: Mail,
  label: "Email",
  value: "info@worldimmigration.it"
}, {
  icon: Phone,
  label: "Telefono",
  value: "+39 049 86 40 662"
}, {
  icon: Phone,
  label: "Cellulare",
  value: "+39 345 84 74 911"
}];
const consultationOptions = [{
  icon: Monitor,
  title: "Prenota Consulenza Online",
  description: "Colloquio in videochiamata con i nostri esperti di immigrazione.",
  href: "/ContactsPage",
  link: "https://calendly.com/worldimmigration-ana_delgado/consulenza-online"
}, {
  icon: Calendar,
  title: "Prenota Consulenza in Studio",
  description: "Incontro presenziale riservato presso la nostra sede principale.",
  href: "/ContactsPage",
  link: "https://calendly.com/worldimmigration-ana_delgado/30min"
}, {
  icon: Building,
  title: "Richiedi una Consulenza\nPresso la Tua Sede Aziendale",
  description: "Soluzioni su misura per aziende, istituti e mobilità internazionale.",
  href: "/CompanyServicesPage"
}];
export default function ContactConsultation() {
  return <section id="contactconsultation" className="bg-background py-16 md:py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-lg bg-primary/5 blur-[120px]" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-lg bg-accent/10 blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div className="w-full">
            <Card className="bg-white/80 backdrop-blur-xl border-white/20 shadow-2xl rounded-2xl overflow-hidden">
              <CardHeader className="pb-8 pt-10 px-10 bg-primary/5">
                <CardTitle className="font-default text-3xl md:text-4xl text-primary font-bold">
                  WORLD IMMIGRATION
                  <span className="block text-lg font-medium text-primary/70 mt-2">
                    DI DELGADO
                  </span>
                </CardTitle>
              </CardHeader>
              <CardContent className="px-10 py-10 flex flex-col gap-8">
                <p className="text-muted-foreground text-lg leading-relaxed">
                  Siamo a vostra disposizione per fornire assistenza qualificata su visti, immigrazione e mobilità internazionale.
                </p>
                
                <div className="flex flex-col gap-6 mt-4">
                  {contactDetails.map((detail, i) => <div data-index={i} key={i} className="flex items-start gap-5 group">
                      <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center shrink-0 group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                        <detail.icon className="w-5 h-5 text-primary group-hover:text-primary-foreground transition-colors duration-300" />
                      </div>
                      <div className="flex flex-col pt-1">
                        <span className="text-sm font-semibold text-muted-foreground uppercase tracking-wider mb-1">
                          {detail.label}
                        </span>
                        <span className="text-lg font-medium text-primary">
                          {detail.value}
                        </span>
                      </div>
                    </div>)}
                </div>
              </CardContent>
            </Card>
          </div>

          {}
          <div className="w-full flex flex-col gap-6">
            <div className="mb-4">
              <h2 className="font-default text-3xl md:text-4xl font-bold text-primary mb-4">
                Inizia il tuo percorso
              </h2>
              <p className="text-muted-foreground text-lg">
                Scegli la modalità di consulenza più adatta alle tue esigenze personali o aziendali.
              </p>
            </div>

            {consultationOptions.map((option, i) => <div data-index={i} key={i}>
                <Button asChild variant="default" className="w-full h-auto py-6 px-6 md:px-8 flex items-center justify-between bg-secondary text-secondary-foreground hover:bg-secondary/90 hover:text-secondary-foreground transition-all duration-300 rounded-xl shadow-lg hover:shadow-xl group border border-transparent hover:border-secondary/50">
                  <Link to={option.link ?? option.href} className="flex items-center w-full text-left">
                    <div className="flex items-center gap-6 w-full">
                      <div className="w-14 h-14 rounded-lg bg-white/10 flex items-center justify-center shrink-0 group-hover:bg-white/20 transition-colors duration-300">
                        <option.icon className="w-6 h-6" />
                      </div>
                      <div className="flex flex-col flex-1">
                        <span className="font-default text-xl font-semibold whitespace-pre-line leading-tight">
                          {option.title}
                        </span>
                      </div>
                      <ArrowRight className="w-6 h-6 opacity-50 group-hover:opacity-100 group-hover:translate-x-2 transition-all duration-300 shrink-0 hidden sm:block" />
                    </div>
                  </Link>
                </Button>
              </div>)}
          </div>

        </div>
      </div>
    </section>;
}